import http from '../../src/api/axiosConfig'

class ManagePromoCode {

    prefix = '/v1/web/promo-code/'

    loadPromoCodes() {
        return http.get(this.prefix+'list')
    }

    addPromoCode(data) {
        return http.post(this.prefix+'add', data)
    }

    updatePromoCode(data) {
        return http.post(this.prefix+'update', data)
    }
}

export default new ManagePromoCode()
